export const isPremiumGallection = (gallection)=>{
    return !!(gallection === null || gallection === void 0 ? void 0 : gallection.premiumFolderData);
};
export const getPremiumGallectionType = (gallection)=>{
    var _gallection_premiumFolderData;
    return gallection === null || gallection === void 0 ? void 0 : (_gallection_premiumFolderData = gallection.premiumFolderData) === null || _gallection_premiumFolderData === void 0 ? void 0 : _gallection_premiumFolderData.type;
};
